import * as actions from "./actions";

import _ from "underscore";

let initialState = {
  accountInfo: {
    fetching: false,
    fetched: false,
    error: null,
    data: [],
  },

  financings: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },

  financingsIssued: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },

  financingsReady: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },

  investmentInfo: {
    fetching: false,
    fetched: false,
    data: [],
  },

  loansForPayout: {
    fetching: false,
    fetched: false,
    data: [],
  },
};

const financing = (state = initialState, action) => {
  switch (action.type) {
    // GET FINANCINGS
    case actions.FINANCINGS_LIST_GET_REQUEST:
      if (action.financingType == "Issued") {
        return Object.assign({}, state, {
          financingsIssued: Object.assign({}, state.financingsIssued, {
            fetching: true,
            error: null,
            data: [],
          }),
        });
      } else if (action.financingType == "Ready") {
        return Object.assign({}, state, {
          financingsReady: Object.assign({}, state.financingsReady, {
            fetching: true,
            error: null,
            data: [],
          }),
        });
      } else {
        return Object.assign({}, state, {
          financings: Object.assign({}, state.financings, {
            fetching: true,
            error: null,
            data: [],
          }),
        });
      }

    case actions.FINANCINGS_LIST_GET_SUCCESS: {
      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          fetching: false,
          fetched: true,
          data: action.response,
        }),
      });
    }
    case actions.FINANCINGS_LIST_GET_ERROR:
      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          fetching: false,
          error: action.error,
        }),
      });

    case actions.FINANCING_LIST_CHANGE_PAGE:
      if (action.financingType == "Issued") {
        return Object.assign({}, state, {
          financingsIssued: Object.assign({}, state.financingsIssued, {
            table: Object.assign({}, state.financingsIssued.table, {
              pagination: Object.assign(
                {},
                state.financingsIssued.table.pagination,
                {
                  page: action.page,
                },
              ),
            }),
          }),
        });
      } else if (action.financingType == "Ready") {
        return Object.assign({}, state, {
          financingsReady: Object.assign({}, state.financingsReady, {
            table: Object.assign({}, state.financingsReady.table, {
              pagination: Object.assign(
                {},
                state.financingsReady.table.pagination,
                {
                  page: action.page,
                },
              ),
            }),
          }),
        });
      } else {
        return Object.assign({}, state, {
          financings: Object.assign({}, state.financings, {
            table: Object.assign({}, state.financings.table, {
              pagination: Object.assign({}, state.financings.table.pagination, {
                page: action.page,
              }),
            }),
          }),
        });
      }

    case actions.FINANCING_LIST_CHANGE_FILTER:
      if (action.financingType == "Issued") {
        return Object.assign({}, state, {
          financingsIssued: Object.assign({}, state.financingsIssued, {
            table: Object.assign({}, state.financingsIssued.table, {
              currentFilter: Object.assign(
                {},
                state.financingsIssued.table.currentFilter,
                {
                  ...action.filter,
                },
              ),
            }),
          }),
        });
      } else if (action.financingType == "Ready") {
        return Object.assign({}, state, {
          financingsReady: Object.assign({}, state.financingsReady, {
            table: Object.assign({}, state.financingsReady.table, {
              currentFilter: Object.assign(
                {},
                state.financingsReady.table.currentFilter,
                {
                  ...action.filter,
                },
              ),
            }),
          }),
        });
      } else {
        return Object.assign({}, state, {
          financings: Object.assign({}, state.financings, {
            table: Object.assign({}, state.financings.table, {
              currentFilter: Object.assign(
                {},
                state.financings.table.currentFilter,
                {
                  ...action.filter,
                },
              ),
            }),
          }),
        });
      }

    // LOANS FOR PAYOUT
    case actions.LOANS_FOR_PAYOUT_REQUEST:
      return Object.assign({}, state, {
        loansForPayout: Object.assign({}, state.loansForPayout, {
          fetching: true,
          error: null,
          data: [],
        }),
      });

    case actions.LOANS_FOR_PAYOUT_SUCCESS:
      return Object.assign({}, state, {
        loansForPayout: Object.assign({}, state.loansForPayout, {
          fetching: false,
          fetched: true,
          data: action.response,
        }),
      });

    case actions.LOANS_FOR_PAYOUT_ERROR:
      return Object.assign({}, state, {
        loansForPayout: Object.assign({}, state.loansForPayout, {
          fetching: false,
          error: action.error,
        }),
      });

    case actions.FINANCING_CLOSE_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financings.data, (item) => {
        return item.Id == id;
      });

      let toChange = Object.assign(
        {},
        state.financings.data[toChangeIndex],
        {},
      );
      toChange.Open = false;

      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          data: [
            ...state.financings.data.slice(0, toChangeIndex),
            toChange,
            ...state.financings.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.FINANCING_OPEN_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financings.data, (item) => {
        return item.Id == id;
      });

      let toChange = Object.assign(
        {},
        state.financings.data[toChangeIndex],
        {},
      );
      toChange.Open = true;

      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          data: [
            ...state.financings.data.slice(0, toChangeIndex),
            toChange,
            ...state.financings.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.FINANCING_UNPUBLISH_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financings.data, (item) => {
        return item.IntId == id;
      });

      let toChange = Object.assign({}, state.financings.data[toChangeIndex], {
        Published: false,
      });

      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          data: [
            ...state.financings.data.slice(0, toChangeIndex),
            toChange,
            ...state.financings.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.FINANCING_PUBLISH_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financings.data, (item) => {
        return item.IntId == id;
      });

      let toChange = Object.assign({}, state.financings.data[toChangeIndex], {
        Published: true,
      });

      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          data: [
            ...state.financings.data.slice(0, toChangeIndex),
            toChange,
            ...state.financings.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    // Fetching investment info for a credit
    case actions.FINANCING_INVESTMENT_INFO_REQUEST:
      return Object.assign({}, state, {
        investmentInfo: Object.assign({}, state.investmentInfo, {
          fetching: true,
          fetched: false,
        }),
      });
    case actions.FINANCING_INVESTMENT_INFO_SUCCESS:
      return Object.assign({}, state, {
        investmentInfo: Object.assign({}, state.investmentInfo, {
          fetching: false,
          fetched: true,
          data: state.investmentInfo.data.concat(action.response),
        }),
      });
    case actions.FINANCING_INVESTMENT_INFO_ERROR:
      return Object.assign({}, state, {
        investmentInfo: Object.assign({}, state.investmentInfo, {
          fetching: false,
          error: action.error,
        }),
      });

    // Fetching additional account infos
    case actions.FINANCING_BOOKING_ACCOUNT_INFO_REQUEST:
      return Object.assign({}, state, {
        accountInfo: Object.assign({}, state.accountInfo, {
          fetching: true,
          fetched: false,
        }),
      });
    case actions.FINANCING_BOOKING_ACCOUNT_INFO_SUCCESS:
      return Object.assign({}, state, {
        accountInfo: Object.assign({}, state.accountInfo, {
          data: [...state.accountInfo.data, action.response],
          fetching: false,
          fetched: true,
        }),
      });
    case actions.FINANCING_BOOKING_ACCOUNT_INFO_ERROR:
      return Object.assign({}, state, {
        accountInfo: Object.assign({}, state.accountInfo, {
          fetching: false,
          error: action.error,
        }),
      });

    // Releaseing financeings
    case actions.FINANCING_REALISE_REQUEST: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financingsReady.data, (item) => {
        return item.Id == id;
      });

      let toChange = Object.assign(
        {},
        state.financingsReady.data[toChangeIndex],
        {},
      );
      toChange.financingsReleasing = true;

      return Object.assign({}, state, {
        financingsReady: Object.assign({}, state.financingsReady, {
          data: [
            ...state.financingsReady.data.slice(0, toChangeIndex),
            toChange,
            ...state.financingsReady.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.FINANCING_REALISE_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financingsReady.data, (item) => {
        return item.Id == id;
      });

      return Object.assign({}, state, {
        financingsReady: Object.assign({}, state.financingsReady, {
          data: [
            ...state.financingsReady.data.slice(0, toChangeIndex),
            ...state.financingsReady.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.FINANCING_REALISE_ERROR: {
      let id = action.financingId;
      let toChangeIndex = _.findIndex(state.financingsReady.data, (item) => {
        return item.Id == id;
      });

      let toChange = Object.assign(
        {},
        state.financingsReady.data[toChangeIndex],
        {},
      );
      toChange.financingsReleasing = false;
      toChange.financingsError = action.error;

      return Object.assign({}, state, {
        financingsReady: Object.assign({}, state.financingsReady, {
          data: [
            ...state.financingsReady.data.slice(0, toChangeIndex),
            toChange,
            ...state.financingsReady.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.FINANCING_REGISTER_PAYOUT_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.loansForPayout.data, (item) => {
        return item.Id == id;
      });

      let data = state.loansForPayout.data.slice();
      data.splice(toChangeIndex, 1);

      return Object.assign({}, state, {
        loansForPayout: Object.assign({}, state.loansForPayout, {
          data: data,
        }),
      });
    }

    case actions.FINANCING_REGISTER_PAYOUT_ERROR: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.loansForPayout.data, (item) => {
        return item.Id == id;
      });

      let toChange = Object.assign(
        {},
        state.loansForPayout.data[toChangeIndex],
        {},
      );
      toChange.loansForPayout = action.error;

      return Object.assign({}, state, {
        loansForPayout: Object.assign({}, state.loansForPayout, {
          ...state.loansForPayout.data.slice(0, toChangeIndex),
          toChange,
          ...state.loansForPayout.data.slice(toChangeIndex + 1),
        }),
      });
    }

    default:
      return state;
  }
};

export default financing;
